<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm1 16V3h14v14H3Zm2.757-7.893a1 1 0 1 0-1.414 1.414l3.535 3.536a1 1 0 0 0 1.415 0l6.364-6.364a1 1 0 0 0-1.415-1.415l-5.656 5.657-2.829-2.828Z" />
    </svg>
</template>
